export const savePermission=(token)=>{
    localStorage.setItem("user_permission",token)
}
export const getPermission=()=>{
    return localStorage.getItem("user_permission")
}

export const getUserName=()=>{
    return localStorage.getItem('username')
}
export const saveUserName=(username)=>{
    return localStorage.setItem('username',username)
}
export const getUserToken=()=>{
    return localStorage.getItem('usertoken')
}
export const saveUserToken=(username)=>{
    return localStorage.setItem('usertoken',username)
}
export const saveUserId=(userid)=>{
    localStorage.setItem("userid",userid)

}
export const getUserId=()=>{
    return localStorage.getItem("userid")

}

export const getUserStatus=()=>{
    return localStorage.getItem("userstatus")
}
export const saveUserStatus=(status)=>{
    return localStorage.setItem("userstatus",status)
}


export const getColumns=()=>{
    return localStorage.getItem('columns')
}
export const saveColumns=(username)=>{
    return localStorage.setItem('columns',username)
}
export const isLogined=()=>{
    if(getUserName()){
        return true;
    }
    return false;
}



export const saveApartmentId=(userid)=>{
    localStorage.setItem("apartmentid",userid)

}
export const getApartmentId=()=>{
    return localStorage.getItem("apartmentid")

}